import { Injectable, signal } from '@angular/core';
import {
  getCachedGeolocation,
  getFormGeolocation,
  UserGeolocation,
} from '../utils/geolocation';

@Injectable({ providedIn: 'root' })
export class GeolocationService {
  private _geolocation = signal<UserGeolocation | null>(null);
  public readonly geolocation = this._geolocation.asReadonly();

  prefetch(): void {
    void this.ensureReady();
  }

  async ensureReady(): Promise<UserGeolocation | null> {
    const cached = this.getForPayload();
    if (cached)
      return cached;

    const geo = await getCachedGeolocation();
    if (geo)
      this._geolocation.set(geo);
    return geo;
  }

  getForPayload(): UserGeolocation | null {
    return this._geolocation() ?? getFormGeolocation();
  }
}
